/*
  One definition of "the public intake surface", read from two places that must not
  drift apart (steward-app#721):

    1. BUILD TIME — `vite.config.ts` puts this pattern in workbox's
       `navigateFallbackDenylist`, so an intake navigation is never answered out of
       the precached app shell.
    2. RUN TIME — `updatePolicy.ts` treats these paths as the one surface where a
       waiting service worker is applied at detection rather than on the next router
       PUSH.

  Both exist for the same reason, and either one alone only half works, so they share
  a definition rather than each carrying its own spelling of `/intake`. This file
  therefore lives in `src/` but is BUILD configuration as much as app code: it imports
  nothing, so the vite config can pull it in without dragging the app along.

  The two intake entry points are `/intake/{firmSlug}` on the shared app host and
  `/intake` on a firm's own branded host (src/intake/IntakePage.tsx), which is why the
  bare path matches as well as the prefixed one. `/intakes` must NOT match, and neither
  must the authenticated advisor-side prospects list (`/advisor/clients/prospects`,
  `/advisor/intakes` before steward-app#1429).

  The `\?` branch is not decoration: workbox matches a denylist entry against
  `pathname + search`, not the pathname alone, so without it a branded-host
  `/intake?ref=…` link would fall straight back into the shell it is meant to avoid.
  `window.location.pathname` never carries a `?`, so the same pattern stays exact for
  the run-time predicate.
*/
export const INTAKE_NAVIGATION_PATTERN = /^\/intake(\/|\?|$)/;

/** Is this the public, unauthenticated client intake form? */
export function isIntakePath(pathname: string): boolean {
  return INTAKE_NAVIGATION_PATTERN.test(pathname);
}
